import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonLabel,
  IonList,
  IonRow,
} from "@ionic/react";
import dayjs from "dayjs";
import "dayjs/locale/es";
import axios from "axios";
import {
  calendar,
  calendarOutline,
  close,
  closeOutline,
  print,
  printOutline,
} from "ionicons/icons";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import {
  convertToPlain,
  obtenerNombreDia,
} from "../../utils/funcionalidadesStrings";
import {
  Column,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import {
  Accordion,
  AccordionDetails,
  AccordionGroup,
  AccordionSummary,
  AspectRatio,
  Box,
  Button,
  Card,
  Typography,
} from "@mui/joy";
import ComprobanteTurno from "../../components/formComponents/ComprobanteTurno/ComprobanteTurno";
import { Close, LibraryAdd, Person, Print } from "@mui/icons-material";
import useTituloPagina from "../../hooks/tituloPagina";
import "./MainPage.css";

const MainPage = (props) => {
  const [cargando, setCargando] = useState(false);
  const [paciente, setPaciente] = useState({});

  const [turnoSeleccionado, setTurnoSeleccionado] = useState({});
  const [abrirModalCancelarReserva, setAbrirModalCancelarReserva] =
    useState(false);
  const [abrirComprobanteTurno, setAbrirComprobanteTurno] = useState(false);

  const [listadoTurnos, setListadoTurnos] = useState([]);
  const [prestadoresRecientes, setPrestadoresRecientes] = useState([]);
  const [accordionPrestadoresRecientesAbierto, setAccordionPrestadoresRecientesAbierto] =
    useState(false);
  const autoAperturaPrestadoresRecientesAplicada = useRef(false);
  const [estudios, setEstudios] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };
  const history = useHistory();
  useTituloPagina();

  const obtenerFotoPrestador = (prestador = {}) => {
    const foto = [
      prestador.foto,
      prestador.Foto,
      prestador.fotoWeb,
      prestador.FotoWeb,
      prestador.imagen,
      prestador.Imagen,
      prestador.imagenWeb,
      prestador.ImagenWeb,
      prestador.fotoBase64,
      prestador.FotoBase64,
      prestador.imagenBase64,
      prestador.ImagenBase64,
    ].find((campo) => typeof campo === "string" && campo.trim() !== "");

    if (typeof foto !== "string" || foto.trim() === "") {
      return "";
    }

    const fotoNormalizada = foto.trim();

    if (
      fotoNormalizada.startsWith("data:") ||
      fotoNormalizada.startsWith("http://") ||
      fotoNormalizada.startsWith("https://")
    ) {
      return fotoNormalizada;
    }

    return `data:image/jpeg;base64,${fotoNormalizada}`;
  };

  const traerTurnosPaciente = async (paciente) => {
    let turnosFuturos = null;
    let tmpPrestadoresRecientes = null;
    let prestadores = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const servicio = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          } else {
            return null;
          }
        });
      if (servicio !== null) {
        const prestadoresResponse = await axios.get(
          `${url}Prestadores?mutuales=${paciente.mutual}`,
          config
        );
        if (prestadoresResponse.data.length !== 0) {
          prestadores = prestadoresResponse.data;
        }

        const response = await axios.get(
          `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}&servicio=${servicio[0].codigo}`,
          config
        );
        if (response.data.length !== 0) {
          turnosFuturos = response.data;
          tmpPrestadoresRecientes = response.data;

          turnosFuturos = turnosFuturos.filter((turno) => {
            return dayjs(new dayjs()).isBefore(dayjs(turno.fecha));
          });
          turnosFuturos = turnosFuturos.sort((a, b) => {
            const fechaA = dayjs(a.fecha);
            const fechaB = dayjs(b.fecha);

            if (fechaA.isBefore(fechaB)) {
              return -1;
            } else if (fechaA.isAfter(fechaB)) {
              return 1;
            } else {
              const horaA = dayjs(a.hora, "HH:mm:ss");
              const horaB = dayjs(b.hora, "HH:mm:ss");

              if (horaA.isBefore(horaB)) {
                return -1;
              } else if (horaA.isAfter(horaB)) {
                return 1;
              } else {
                return 0;
              }
            }
          });
          turnosFuturos = turnosFuturos.slice(0, 5);

          tmpPrestadoresRecientes = tmpPrestadoresRecientes
            .sort((a, b) => dayjs(b.fecha).diff(dayjs(a.fecha)))
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  (t) =>
                    t.prestadorCod === value.prestadorCod &&
                    t.prestadorNom === value.prestadorNom
                )
            )
            .slice(0, 4)
            .map((turno) => {
              return {
                prestadorCod: turno.prestadorCod,
                prestadorNom: turno.prestadorNom,
                especialidadCod: turno.especialidad,
                especialidadNom: turno.especialidadNom,
                imageSrc: obtenerFotoPrestador(
                  prestadores.find(
                    (prestador) => prestador.codigo === turno.prestadorCod
                  ) || {}
                ),
              };
            })
            .sort((a, b) => a.prestadorNom.localeCompare(b.prestadorNom));
        } else {
          turnosFuturos = [];
          tmpPrestadoresRecientes = [];
        }
        setListadoTurnos(turnosFuturos);
        setPrestadoresRecientes(tmpPrestadoresRecientes);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar sus proximos turnos",
        "rojo"
      );
    }
  };

  const traerEstudios = async (paciente) => {
    let estudios = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}Estudios`, config);
      if (response.data.length !== 0) {
        estudios = response.data;
      }

      estudios = estudios.map((estudio) => {
        return {
          ...estudio,
          text: estudio.nombre,
        };
      });

      setEstudios(estudios);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar l registradas en el sistema",
        "rojo"
      );
    }
  };

  const TraerServicio = async (paciente) => {
    try {
      let servicioResponse = {};
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };
      servicioResponse = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          }
        });
      setServicios(servicioResponse);
    } catch (e) {}
  };
  const CancelarTurno = async () => {
    try {
      const urlAxioPP = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };

      let servicio = null;
      const serviciosResponse = await axios.get(
        `${urlAxioPP}Servicios`,
        config
      );

      if (serviciosResponse.data.length !== 0) {
        servicio = serviciosResponse.data[0];
      }

      if (servicio?.codigo !== null && turnoSeleccionado) {
        const cancelarTurnoResponse = await axios.patch(
          `${urlAxioPP}Turnos/ActualizarTurno/${turnoSeleccionado.codigo}`,
          {
            codigo: turnoSeleccionado.codigo,
            paciente: paciente.codigo,
            aCancelar: false,
            cancelado: true,
            asistio: false,
            observaciones: "Cancelado por el paciente via web",
          },
          config
        );

        if (cancelarTurnoResponse.status === 200) {
          mostrarNotificacion(
            true,
            "El turno se canceló correctamente",
            "verde"
          );
        } else {
          mostrarNotificacion(
            true,
            "Ocurrió un problema al intentar cancelar el turno",
            "rojo"
          );
        }
      }
    } catch (error) {
      try {
        const urlAxioPP = localStorage.getItem("urlAxioPP");
        const config = {
          headers: { Authorization: `Bearer ${paciente.token}` },
        };

        const cancelarTurnoResponse = await axios.patch(
          `${urlAxioPP}Turnos/Quitar/${turnoSeleccionado.codigo}`,
          "",
          config
        );

        if (cancelarTurnoResponse.status === 200) {
          mostrarNotificacion(
            true,
            "El turno se canceló correctamente",
            "verde"
          );
        } else {
          mostrarNotificacion(
            true,
            "Ocurrió un problema al intentar cancelar el turno",
            "rojo"
          );
        }
      } catch (finalError) {
        mostrarNotificacion(
          true,
          "Error: " + (finalError.response?.data || finalError.message),
          "rojo"
        );
      }
    }
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        traerTurnosPaciente(sesion);

        traerEstudios(sesion);
        TraerServicio(sesion);
        setPaciente(sesion);
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  useEffect(() => {
    if (
      prestadoresRecientes.length > 0 &&
      !autoAperturaPrestadoresRecientesAplicada.current
    ) {
      setAccordionPrestadoresRecientesAbierto(true);
      autoAperturaPrestadoresRecientesAplicada.current = true;
    }
  }, [prestadoresRecientes]);

  const handleClickRedirigir = (destino) => {
    switch (destino) {
      case "Reservar turno":
        history.push({ pathname: "/portal/Reservar turno" });
        break;
      case "Horarios":
        history.push({ pathname: "/portal/Horarios" });
        break;
      case "Turnos":
        history.push({ pathname: "/portal/Turnos" });
        break;
      case "Estudios":
        history.push({ pathname: "/portal/Estudios" });
        break;
      default:
        mostrarNotificacion(true, "Seleccion invalida", "rojo");
        break;
    }
  };

  const togleAbrirCerrarCancelarReserva = () => {
    if (abrirModalCancelarReserva) {
      setTurnoSeleccionado({});
    }
    setAbrirModalCancelarReserva(!abrirModalCancelarReserva);
  };

  const handleClickSeleccionarTurno = (turno) => {
    setTurnoSeleccionado(turno);
    togleAbrirCerrarCancelarReserva();
  };

  const handleClickCancelarReserva = async () => {
    togleAbrirCerrarCancelarReserva();
    setCargando(true);
    await CancelarTurno();
    await traerTurnosPaciente(paciente);
    setCargando(false);
  };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "3516183749";
    navigator.clipboard.writeText(phoneNumber);

    mostrarNotificacion(
      true,
      "Se ha copiado el numero de telefono a su portapapeles",
      ""
    );
  };

  const handleClickComprobanteTurno = (turno) => {
    setTurnoSeleccionado({
      codigo: turno.codigo,
      equipoNom: turno.equipoNom,
      especialidadNom: turno.especialidadNom,
      estudioNom: turno.estudioNom,
      fecha: turno.fecha,
      hora: turno.hora,
      mutualNom: turno.mutualNom,
      prestadorNom: turno.prestadorNom,
      servicio: turno.servicio,
      apellido: paciente.apellido,
      nombre: paciente.nombre,
      mutualNombre: paciente.mutualNombre,
      mutualAfiliado: paciente.mutualAfiliado,
      hc: paciente.hc,
      documentoTipoNombre: paciente.documentoTipoNombre,
      documentoNro: paciente.documentoNro,
      celular: paciente.celular,
      email: paciente.email,
      lugarAtencion:
        servicios.find((item) => item.codigo === turno.servicio)?.direccion ||
        "no disponible",
      preparacionEstudio: null,
    });
    setAbrirComprobanteTurno(true);
  };

  const togleAbrirCerrarComprobanteTurno = () => {
    if (abrirComprobanteTurno) {
      setTurnoSeleccionado({});
    }
    setAbrirComprobanteTurno(!abrirComprobanteTurno);
  };

  const handleClickReservarTurnoPrestador = (prestadorData) => {
    const prestadorInfo =
      typeof prestadorData === "object"
        ? prestadorData
        : { prestadorCod: prestadorData };

    history.push({
      pathname: "/portal/Reservar turno",
      state: {
        prestador: prestadorInfo.prestadorCod,
        especialidadCod: prestadorInfo.especialidadCod,
        especialidadNom: prestadorInfo.especialidadNom,
        prestadorNom: prestadorInfo.prestadorNom,
        accesoDirecto: true,
      },
    });
  };

  const renderPrestadoresRecientes = (seePreviusVersion) => {
    return (
      <Row
        style={{ textAlign: "start" }}
        alignItems="stretch"
        container
        spacing={2}
        className="prestadores-recientes-grid"
      >
        {prestadoresRecientes.map((fila) => (
          <Column xs={12} md={6} xl={4} key={fila.prestadorCod}>
            <Card
              style={{ marginBottom: "7.5px", padding: "14px 18px" }}
              variant="outlined"
              className="prestador-reciente-card"
            >
              <div className="prestador-reciente-contenido amarillo-sol">
                <div className="prestador-reciente-detalle">
                  {fila.imageSrc ? (
                    <div className="prestador-reciente-foto-frame">
                      <img
                        src={fila.imageSrc}
                        alt={fila.prestadorNom}
                        className="prestador-reciente-foto"
                      />
                    </div>
                  ) : (
                    <Person sx={{ color: "#6b33b8" }} />
                  )}
                  <Typography
                    sx={{ color: "#6b33b8" }}
                    level="body-sm"
                    className="prestador-reciente-texto"
                  >{`${fila.prestadorNom} - ${fila.especialidadNom}`}</Typography>
                </div>
                <Button
                  type="button"
                  variant="plain"
                  color="neutral"
                  className="prestador-reciente-accion"
                  onClick={() => handleClickReservarTurnoPrestador(fila)}
                >
                  <Typography level="title-sm" sx={{ color: "#6b33b8" }}>
                    {`Reservar turno`.toUpperCase()}
                  </Typography>
                  <LibraryAdd sx={{ color: "#6b33b8" }} />
                </Button>
              </div>
            </Card>
          </Column>
        ))}
      </Row>
    );
    //     </IonGrid>
    //   </>
    // );
  };

  const renderTurnosLista = (seePreviusVersion) => {
    return (
      <IonGrid
        className="tabla"
        style={{
          margin: "10px",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <IonIcon slot="start" md={calendar} ios={calendarOutline} />
        <Column className="" xs={12} marginBottom={1}>
          <Row>
            <Typography level="body-sm">Proximos turnos</Typography>
          </Row>
        </Column>
        {listadoTurnos.map((fila) => (
          <Card
            style={{ marginBottom: "7.5px", padding: "0px 14px" }}
            key={fila.codigo}
          >
            <Row
              className=""
              style={{ textAlign: "start" }}
              alignItems="center"
              container
            >
              <Column
                style={{ textAlign: "start" }}
                xs={6}
                md={8}
                lg={10}
                container
              >
                <Row alignItems="center" container>
                  <Column xs={12} md={6}>
                    <Typography level="title-sm" sx={{ color: "#6b33b8" }}>
                      {fila.prestadorNom === "EQUIPOS"
                        ? `${fila.estudioNom}`
                        : `${fila.prestadorNom + " - " + fila.especialidadNom}`}
                    </Typography>
                  </Column>
                  <Column xs={12} md={6}>
                    <Typography level="title-sm">
                      {`${obtenerNombreDia(
                        dayjs(fila.fecha).format("dddd")
                      )} ${dayjs(fila.fecha).format("DD")} de ${dayjs(
                        fila.fecha
                      ).format("MMMM, YYYY")} a las ${dayjs(fila.hora).format(
                        "HH:mm"
                      )}`}
                    </Typography>
                  </Column>
                </Row>
                <Row className="" alignItems="center" container>
                  <Column xs={12} md={6}>
                    <Typography level="body-sm">{`${fila.mutualNom}`}</Typography>
                  </Column>
                  <Column xs={12} md={6}>
                    <Typography level="body-sm">
                      {`Estado: ${
                        fila.asistio
                          ? "Asistido"
                          : fila.aCancelar
                          ? "Pendiente"
                          : "Cancelado"
                      }`}
                    </Typography>
                  </Column>
                </Row>
                <Row className="" alignItems="center" container>
                  <Column xs={12}>
                    <Typography level="body-sm">
                      {fila.prestadorNom === "EQUIPOS" &&
                      estudios.filter(
                        (estudio) => estudio.codigo === fila.estudio
                      )[0]?.preparacion !== ""
                        ? convertToPlain(
                            estudios.filter(
                              (estudio) => estudio.codigo === fila.estudio
                            )[0]?.preparacion
                          )
                        : null}
                    </Typography>
                  </Column>
                </Row>
              </Column>
              <Column container xs={6} md={4} lg={2}>
                <Row container>
                  {(dayjs().format("YYYY-MM-DD") !==
                    dayjs(fila.fecha).format("YYYY-MM-DD") ||
                    (dayjs().format("YYYY-MM-DD") ===
                      dayjs(fila.fecha).format("YYYY-MM-DD") &&
                      dayjs(fila.hora).format("HH:mm") >
                        dayjs().format("HH:mm"))) &&
                  fila.aCancelar ? (
                    <Column xs={12} container>
                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() => handleClickComprobanteTurno(fila)}
                        style={{ margin: "0px" }}
                      >
                        <IonIcon
                          aria-label="Cancelar turno"
                          ios={printOutline}
                          md={print}
                          style={{ color: "#6b33b8" }}
                        />
                        <IonLabel style={{ color: "#6b33b8" }}>
                          Comprobante
                        </IonLabel>
                      </IonButton>
                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() => handleClickSeleccionarTurno(fila)}
                        style={{ margin: "0px" }}
                      >
                        <IonIcon
                          aria-label="Cancelar turno"
                          ios={closeOutline}
                          md={close}
                          style={{ color: "#6b33b8" }}
                        />
                        <IonLabel style={{ color: "#6b33b8" }}>
                          Cancelar
                        </IonLabel>
                      </IonButton>
                    </Column>
                  ) : (
                    <Column className="" xs={12} container>
                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() => handleClickComprobanteTurno(fila)}
                        style={{ margin: "0px" }}
                      >
                        <IonIcon
                          aria-label="Cancelar turno"
                          ios={printOutline}
                          md={print}
                          style={{ color: "#6b33b8" }}
                        />
                        <IonLabel style={{ color: "#6b33b8" }}>
                          Comprobante
                        </IonLabel>
                      </IonButton>

                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() =>
                          handleClickReservarTurnoPrestador({
                            prestadorCod: fila.prestadorCod,
                            prestadorNom: fila.prestadorNom,
                            especialidadCod: fila.especialidad,
                            especialidadNom: fila.especialidadNom,
                          })
                        }
                        style={{ margin: "0px" }}
                      >
                        <Typography level="title-sm" sx={{ color: "#6b33b8" }}>
                          {`Reservar turno`.toUpperCase()}
                        </Typography>
                        <LibraryAdd sx={{ color: "#6b33b8" }} />
                      </IonButton>
                    </Column>
                  )}
                </Row>
              </Column>
            </Row>
          </Card>
        ))}
      </IonGrid>
    );
  };

  const renderAccesoRapido = (emoji, titulo, subtitulo, accion) => (
    <Card
      className="quick-access-card"
      variant="outlined"
      onClick={() => handleClickRedirigir(accion)}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleClickRedirigir(accion);
        }
      }}
    >
      <Box className="quick-access-content">
        <Box className="quick-access-icon" aria-hidden="true">
          {emoji}
        </Box>
        <Box className="quick-access-copy">
          <Typography level="title-md" className="quick-access-title">
            {titulo}
          </Typography>
          <Typography level="body-xs" className="quick-access-subtitle">
            {subtitulo}
          </Typography>
        </Box>
        <Box className="quick-access-arrow" aria-hidden="true">
          →
        </Box>
      </Box>
    </Card>
  );

  return (
    <IonGrid className="home-dashboard">
      <IonRow>
        <IonCol sizeXs="12" sizeMd="6">
          {renderAccesoRapido(
            "🩺",
            "Reservar un nuevo turno",
            "Elegí especialidad y profesional",
            "Reservar turno"
          )}
        </IonCol>

        <IonCol sizeXs="12" sizeMd="6">
          {renderAccesoRapido(
            "📅",
            "Consultar mis turnos",
            "Revisá próximos y anteriores",
            "Turnos"
          )}
        </IonCol>

        <IonCol sizeXs="12" sizeMd="6">
          {renderAccesoRapido(
            "👁️",
            "Consultar mis estudios",
            "Consultá tus estudios realizados",
            "Estudios"
          )}
        </IonCol>
      </IonRow>

      {listadoTurnos.length !== 0 && renderTurnosLista(true)}
      {prestadoresRecientes.length !== 0 && (
        <AccordionGroup>
          <Accordion
            className="prestadores-recientes-accordion"
            expanded={accordionPrestadoresRecientesAbierto}
            onChange={(event, expanded) =>
              setAccordionPrestadoresRecientesAbierto(expanded)
            }
          >
            <AccordionSummary>Prestadores recientes</AccordionSummary>
            <AccordionDetails className="prestadores-recientes-details">
              {renderPrestadoresRecientes()}
            </AccordionDetails>
          </Accordion>
        </AccordionGroup>
      )}

      <DialogoConfirmacion
        titulo="Cancelar turno"
        texto={`Ha decidido cancelar el turno con el/la profesional ${
          turnoSeleccionado.prestadorNom
        }, con especialidad en ${
          turnoSeleccionado.especialidadNom
        }, para el dia ${obtenerNombreDia(
          dayjs(turnoSeleccionado.fecha).format("dddd")
        )} ${dayjs(turnoSeleccionado.fecha).format("DD")} de ${dayjs(
          turnoSeleccionado.fecha
        ).format("MMMM, YYYY")} a las ${dayjs(turnoSeleccionado.hora).format(
          "HH:mm"
        )}, ¿Esta seguro/a de ello?`}
        open={abrirModalCancelarReserva}
        setOpen={setAbrirModalCancelarReserva}
        handleClickConfirmar={handleClickCancelarReserva}
        colorBotonNo="danger"
        colorBotonSi="success"
        textoBotonNo="No"
        textoBotonSi="Si, cancelo"
      />

      <ComprobanteTurno
        turno={turnoSeleccionado}
        abrir={abrirComprobanteTurno}
        togleAbrirCerrarComprobanteTurno={togleAbrirCerrarComprobanteTurno}
        paciente={paciente}
      />

      <CustomToast
        openToast={toast.open}
        onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />
    </IonGrid>
  );
};

export default MainPage;
